export interface Major {
    id: string;
    code: string;
    name: string;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export interface CreateMajorData {
    code: string;
    name: string;
    description?: string;
    is_active?: boolean;
}

export interface UpdateMajorData {
    code?: string;
    name?: string;
    description?: string;
    is_active?: boolean;
}

export interface MajorFilters {
    search?: string;
    is_active?: boolean;
    page?: number;
    per_page?: number;
}

import api from "./axios";

export const majorApi = {
    async getAll(filters: MajorFilters = {}): Promise<{
        success: boolean;
        message: string;
        data: { items: Major[]; meta: any };
    }> {
        const response = await api.get("/v1/majors", { params: filters });
        return response.data;
    },

    async getById(id: string): Promise<Major> {
        const response = await api.get(`/v1/majors/${id}`);
        return response.data.data;
    },

    async create(data: CreateMajorData): Promise<Major> {
        const response = await api.post("/v1/majors", data);
        return response.data.data;
    },

    async update(id: string, data: UpdateMajorData): Promise<Major> {
        const response = await api.put(`/v1/majors/${id}`, data);
        return response.data.data;
    },

    async delete(id: string): Promise<void> {
        await api.delete(`/v1/majors/${id}`);
    },

    async getActive(): Promise<Major[]> {
        const response = await api.get("/v1/majors/active");
        return response.data.data || [];
    },
};

export default majorApi;
